// extracted by mini-css-extract-plugin
export default {"FaqBgColor":"index__FaqBgColor--1hxqD","faqBgColor":"index__FaqBgColor--1hxqD","homeBgColor":"index__homeBgColor--rpeLw"};